module.exports = __webpack_public_path__ + "img/audioMp3.d9955adf.svg";